export function parseMoney(value) {
  if (value === undefined || value === null || value === "") {
    return 0;
  }

  const parsed = typeof value === "number" ? value : Number.parseFloat(value);

  return Number.isFinite(parsed) ? parsed : 0;
}

export function rentalDurationMinutes(rentalStartAt, rentalEndAt) {
  const start = Date.parse(String(rentalStartAt).replace(" ", "T"));
  const end = Date.parse(String(rentalEndAt).replace(" ", "T"));

  if (!Number.isFinite(start) || !Number.isFinite(end)) {
    return 0;
  }

  return Math.floor((end - start) / 60_000);
}

export function meetsMinimumRentalDuration(rentalStartAt, rentalEndAt, minimumDays) {
  return rentalDurationMinutes(rentalStartAt, rentalEndAt) >= Math.max(0, minimumDays) * 24 * 60;
}

export function buildDeliverySummary(order) {
  const deliveryFee = parseMoney(order?.delivery_fee);
  const afterHoursSurcharge = parseMoney(order?.after_hours_surcharge);
  const waitingFee = parseMoney(order?.waiting_fee);

  return {
    deliveryFee,
    afterHoursSurcharge,
    waitingFee,
    totalFee: deliveryFee + afterHoursSurcharge + waitingFee,
  };
}

export function formatDeliveryStatus(status) {
  if (!status) {
    return "Pending";
  }

  const labels = {
    collected: "Collected",
    returned: "Returned to branch",
    no_show: "No show",
    en_route: "En route",
  };

  if (labels[status]) {
    return labels[status];
  }

  const label = status
    .split("_")
    .join(" ");

  return label.charAt(0).toUpperCase() + label.slice(1);
}
